import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const deleteRegisterAccess = api((domain) =>
    mutate(
        gql`
            mutation DeleteRegisterAccess($domain: String!) {
                deleteRegisterAccess(domain: $domain)
            }
        `,
        { domain },
        { returns: "deleteRegisterAccess" }
    )
)
